var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"work_bg"},[_c('div',{staticClass:"work_title"},[_c('span',[_vm._v(" 欢迎您"+_vm._s(_vm.userChName)+"登录本系统！ ")])]),_c('div',{staticClass:"work_content"},[_c('storeStatistic',{ref:"storeStatistic"})],1),_c('div',{staticClass:"work_content"},[_c('storeMonthNumStatistic',{ref:"storeMonthNumStatistic"})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }